import { Component, OnInit } from '@angular/core';
import { RouteConfigLoadStart } from '@angular/router';
import { AngularFireAuth } from "@angular/fire/compat/auth";

import { AngularFirestore } from '@angular/fire/compat/firestore';
import * as firebase from 'firebase/app';

import { FirebaseFunctions } from '../../shared/firebase/firebasefunctions.service';
import { switchMap, map } from 'rxjs/operators';

@Component({
  selector: 'app-editsquares',
  templateUrl: './editsquares.component.html',
  styleUrls: ['./editsquares.component.scss']
})
export class EditsquaresComponent implements OnInit {

  gamesId = 'mondaynight2022';
  today = new Date();
  todayStr;
  container = 'games';
  OneThru9 = [6, 1, 3, 5, 0, 8, 9, 7, 4, 2];
  // gamesData;
  gamesDetails;
  data2;
  gamesDetailOriginal ;
  newGame =  {
                "Week": "",
                "Date": "",
                "HomeTeam": "",
                "xValues": [3,2,7,8,5,0,1,4,9,6],
                "AwayTeam": "",
                "yValues": [5,3,0,7,9,1,4,6,8,2],
                "newSquareData": [],
                "pot": "",
                "finalScore": {
                  "HomeTeam": "N/A",
                  "AwayTeam": "N/A"
                }
  };

  constructor(private ff: FirebaseFunctions, private afAuth: AngularFireAuth,) { }

  ngOnInit(): void {
  this.todayStr = this.today.toISOString().split('T')[0].replace(/-/g, '');
  console.log(this.todayStr)

    this.getGamesData();
  }

  addNewGame() {
    console.log('new game');
    const newGame = this.getRandomValuesForGame();
    console.log(newGame);
    this.gamesDetails.push(newGame);

  }

  removeGame(i) {
    this.gamesDetails.splice(i,1);
  }


  getGamesData() {
    this.ff.getDataById(this.container, this.gamesId)
    
    .subscribe(data2 => {
      // console.log(data2);
      this.data2 = data2;
      // this.gamesData = this.data2;
      this.gamesDetails = this.data2.data;
      this.gamesDetailOriginal = this.data2.data;
      console.log(this.gamesDetails)
      // console.log(JSON.stringify(this.gamesDetails))
    })
  }

  restoreBackup() {
    this.ff.getDataById(this.container, this.gamesId + 'Backup') 
    
    .subscribe(data2 => {
      this.data2 = data2;
      this.gamesDetails = this.data2.data;
      console.log(this.gamesDetails)
      // console.log(JSON.stringify(this.gamesDetails))
      this.saveData();
    })
  }

  saveData(){
    // console.log(this.gamesDetails);
    for (let i = 0; i < this.gamesDetails.length; i++) {
      const element = this.gamesDetails[i];
      if (typeof element.xValues === 'string' || element.xValues instanceof String) {
          element.xValues = element.xValues.split(',').map(Number);
      }
      if (typeof element.yValues === 'string' || element.yValues instanceof String) {
          element.yValues = element.yValues.split(',').map(Number);
      }
    }
    for (let i = 0; i < this.gamesDetails.length; i++) {
      const element = this.gamesDetails[i];
      delete element["newSquareData"];
      
    }
    console.log(this.gamesDetails);
    
    this.ff.createOrUpdateDoc_IfLoggedIn(this.container, this.gamesId + "_" + this.todayStr, this.gamesDetailOriginal)
    .subscribe(data => {
      window.alert('Backup Date Success');
    });
    this.ff.createOrUpdateDoc_IfLoggedIn(this.container, this.gamesId + "_Backup", this.gamesDetailOriginal)
    .subscribe(data => {
      window.alert('Backup Success');
    });
    // console.log(this.gamesDetails);

    this.ff.createOrUpdateDoc_IfLoggedIn(this.container, this.gamesId, this.gamesDetails)
      .subscribe(data => {
        window.alert('Success Update');
      });
  }



   shuffle(array) {
      var i = array.length,
          j = 0,
          temp;

      while (i--) {

          j = Math.floor(Math.random() * (i+1));

          // swap randomly chosen element with current element
          temp = array[i];
          array[i] = array[j];
          array[j] = temp;

      }
      console.log(array)
      return array;
  }


    getRandomValuesForGame(){
        const newxValues = [...this.OneThru9];
        const newyValues = [...this.OneThru9];
        this.newGame['xValues'] = this.shuffle(newxValues);
        this.newGame['yValues'] = this.shuffle(newyValues);
        // console.log(JSON.stringify(this.newGame));
        return this.newGame;
  }

}



